import React from 'react'
import Apply from '../components/Apply/Apply'
import AppNavbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'

const ApplyPage = () => {
  return (
    <div>
        <AppNavbar/>
        <Apply/>
        <Footer/>
    </div>
  )
}

export default ApplyPage